import {
  Button,
  Menu,
  Layout,
  Row,
  Col,
  Card,
  Input,
  Tabs,
  Collapse,
  Select,
  Breadcrumb,
  Icon,
  Carousel,
  Form,
  Pagination,
  Radio,
  Dropdown,
  Checkbox,
  Modal,
} from "ant-design-vue";

const components = [
  Button,
  Menu,
  Layout,
  Row,
  Col,
  Card,
  Input,
  Tabs,
  Collapse,
  Select,
  Breadcrumb,
  Icon,
  Carousel,
  Form,
  Pagination,
  Radio,
  Dropdown,
  Checkbox,
  Modal,
];

export const setupAntd = (app) => {
  components.forEach((component) => {
    app.use(component);
  });
};
